import { reservedModeOfPayments } from "features/inventory/data/constants"
const paymentMethodTransformer = (response, flag) => {
  const filteredResponse = flag ? response?.filter(item => reservedModeOfPayments?.includes(item?.key)) : response
  return filteredResponse?.map(e => ({
    ...e,
    key: e?.key,
    label: e?.name,
    value: e?.name,
    id: e?.id,
    cheque: cheque,
    onlinePayment: onlinePayment,
    depositSlip: depositSlip,
    cardPayment: cardPayment,
    bankOrder: bankOrder,
    getBankNames: getBankNames(e),
    PaymentModeAttachmentTypeMappings: e?.PaymentModeAttachmentTypeMappings?.map(item => {
      return {
        ...item,
        mandatory: mandatoryMapper(e?.key, item?.AttachmentType?.key),
        visionRequired:
          item?.attachmentTypeId === 1 ? e?.key === "card_payment" : [2, 3, 6].includes(item?.attachmentTypeId),
      }
    }),
  }))
}

const getBankNames = e => {
  return (
    e.key === "cheque" ||
    e.key === "online_payment" ||
    e.key === "bank_order" ||
    e.key === "pay_order" ||
    e.key === "cash"
  )
}

const mandatoryMapper = (paymentType, paymentMode) => {
  switch (paymentType) {
    case "cheque":
      return paymentMode !== "receipt"
    case "cash":
      return paymentMode !== "receipt"
    case "online_payment":
      return true
    case "bank_loan":
      return true
    case "bank_order":
      return paymentMode !== "receipt"
    case "card_payment":
      return true
  }
}

const cheque = {
  chequeBank: "Bank",
  referenceNumber: "chequeNumber",
  fromAccountNumber: "accountNumber",
  chequeDate: "date",
}

const onlinePayment = {
  bank: "Bank",
  transactionNumber: "serialNumber",
  fromAccountTitle: "fromAccountTitle",
  fromAccountNumber: "fromAccountNumber",
  beneficiaryAccountTitle: "beneficiaryAccountTitle",
  beneficiaryAccountNumber: "accountNumber",
  transactionDate: "date",
}

const cardPayment = {
  dateOfTransaction: "date",
  transactionId: "serialNumber",
}

const depositSlip = {
  depositBank: "Bank",
  depositDate: "date",
  accountNumber: "accountNumber",
  depositSlipNumber: "serialNumber",
}

const bankOrder = {
  payorderBank: "Bank",
  payorderNumber: "payorderNumber",
  beneficiaryAccountNumberPayorder: "fromAccountNumber",
}

export default paymentMethodTransformer
